import { Theme } from "@mui/material/styles";
import rgba from "assets/theme/functions/rgba";

interface Styles {
  [key: string]: any;
}

export const styles = (theme: Theme): Styles => ({
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  circleGroup: {
    display: "flex",
    alignItems: "center"
  },
  circle: {
    width: theme.width.width23_5,
    height: '46px',
    borderRadius: '50%',
    background: theme.palette.extraColors?.circleGrey || '#E6EDED',
    fontweight: theme.typography.fontWeightBold,
    fontSize: theme.typography.size.md,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  firstCircle: {
    marginLeft: '0px',
  },
  active: {
    background: theme.palette.primary.main,
    color: theme.palette.white.main,
    fontWeight: theme.typography.fontWeightBold,
  },
  notActive: {
    background: theme.palette.white.main,
    color: rgba(theme.palette.black.main, 0.5),
    fontWeight: theme.typography.fontWeightBold,
  },
  seperateLine: {
    width: theme.spacing.spacing20,
    border: 'none',
    borderTop: `1px dotted ${theme.palette.white.main}`,
    height: '1px',
    margin: `0px ${theme.spacing.spacing2} 0 ${theme.spacing.spacing2}`,
  },
  activeLine: {
    borderTop: `1px dotted ${theme.palette.black.main}`,
  }
});

